import { AUSTRALIA } from '../SpaceListingConstants';

export const setProfileData = (data) => {
  sessionStorage.setItem('profileListingData', JSON.stringify(data));
};

export const getProfileData = () => {
  const spaceData = JSON.parse(sessionStorage.getItem('profileListingData'));
  const removedTaxInfo = spaceData?.routeList?.filter((res) => {
    return !res.includes(`/dashboard/list-a-space/tax_information`);
  });
  return spaceData?.space_location?.[0]?.spaceCountry === AUSTRALIA
    ? { ...spaceData, routeList: removedTaxInfo }
    : JSON.parse(sessionStorage.getItem('profileListingData'));
};

/** Last path segment for a listing route, e.g. uploading_images */
export const getListingStepSlug = (path = '') => {
  const cleaned = String(path).split('?')[0].replace(/\/+$/, '');
  const parts = cleaned.split('/').filter(Boolean);
  return parts[parts.length - 1] || '';
};

/**
 * Keep navigation inside the current country URL prefix.
 * routeList can be seeded with /all/... while the user is on /Sri-Lanka/...
 */
export const alignListingRouteCountry = (route, pathname = window.location.pathname) => {
  if (!route) return null;

  const currentParts = String(pathname).split('/').filter(Boolean);
  const routeParts = String(route).split('/').filter(Boolean);

  if (currentParts[0] && routeParts.length >= 4 && currentParts[1] === 'dashboard') {
    routeParts[0] = currentParts[0];
    return `/${routeParts.join('/')}`;
  }

  return route;
};

/**
 * Find current step in routeList by step slug (not exact full-path match).
 * Exact pathname indexOf fails when country prefixes differ (e.g. /all vs /Sri-Lanka),
 * which made Next navigate to routeList[0] (Welcome).
 */
export const getListingRouteIndex = (pathname, routeList = getProfileData()?.routeList || []) => {
  const slug = getListingStepSlug(pathname).toLowerCase();
  if (!slug || !Array.isArray(routeList)) return -1;

  return routeList.findIndex((route) => getListingStepSlug(route).toLowerCase() === slug);
};

export const getNextListingRoute = (pathname = window.location.pathname) => {
  const routeList = getProfileData()?.routeList || [];
  const currentIndex = getListingRouteIndex(pathname, routeList);
  if (currentIndex < 0 || currentIndex >= routeList.length - 1) return null;
  return alignListingRouteCountry(routeList[currentIndex + 1], pathname);
};

export const getPreviousListingRoute = (pathname = window.location.pathname) => {
  const routeList = getProfileData()?.routeList || [];
  const currentIndex = getListingRouteIndex(pathname, routeList);
  if (currentIndex <= 0) return null;
  return alignListingRouteCountry(routeList[currentIndex - 1], pathname);
};
